export default __webpack_public_path__ + "static/media/alz.2360d9ca.png";